import { graphql } from 'gatsby';
import { exists, getKey, getLink } from '../../../helpers';

/**
 * ContentCard Widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the content
 * @returns {Object} definition of the widget
 */
export const contentCard = function contentCard(props, locale) {
  const imageAlignment = getKey(props, 'imageAlignment');
  return {
    key: getKey(props, 'key'),
    contentCardId: getKey(props, 'key'),
    title: getKey(props, `title_${locale}`),
    video: getKey(props, `video_${locale}`),
    videoText: getKey(props, `videoText_${locale}`),
    primaryColor: getKey(props, 'primaryColor'),
    secondaryColor: getKey(props, 'secondaryColor'),
    alignImageRight: getKey(props, 'alignImageRight'),
    htmlContent: getKey(props, `htmlContent_${locale}`),
    callToAction: getKey(props, `callToAction_${locale}`),
    link: getLink(getKey(props, 'link'), locale),
    externalEmbed: getKey(props, 'externalEmbed'),
    mainImage: getKey(props, 'mainImage'),
    imageAlignment: exists(imageAlignment) ? imageAlignment : 'center',
    alt: getKey(props, `image_alt_${locale}`),
    detailsLink: getKey(props, `DetailsLink`),
    detailsText: getKey(props, `DetailsText_${locale}`),
  };
}

export default function contentcardprovider(props, locale) {
  const key = getKey(props, 'key');

  return {
    locale,
    contentCardId: key
  };
}


/**
 * GraphQL query
 */
export const query = graphql`
  fragment ContentCards on StrapiWidgetrels {
    contentcard {
      key: id
      title_en
      title_es
      video_en
      video_es
      videoText_en
      videoText_es
      primaryColor
      secondaryColor
      alignImageRight
      htmlContent_en
      htmlContent_es
      callToAction_en
      callToAction_es
      link
      externalEmbed
      widgetPosition
      imageAlignment
      image_alt_en
      image_alt_es
      mainImage {
        childImageSharp {
          fluid(maxWidth: 960, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
`;
